export const PACKAGES_QUERY_PARAM = {
  fromDate: "from_date",
  untilDate: "until_date",
  adults: "adults",
  children: "children",
  origin: "origin",
  destination: "destination",
  searchToken: "search_token",
  roomsCount: "roomsCount",
  packageType: "package_type",
  driverAge: "driver_age",
  packageToken: "packageToken",
} as const;

export type PACKAGES_QUERY_PARAM =
  (typeof PACKAGES_QUERY_PARAM)[keyof typeof PACKAGES_QUERY_PARAM];

export type PackageSearchQueryParams = {
  origin: string;
  destination: string;
  fromDate: string;
  untilDate: string;
  adults?: number;
  children?: number[] | null;
  roomCount: number;
  packageType?: string;
  driverAge?: number;
  packageToken?: string;
};
